import React from "react";

/**
 * https://reactjs.org/docs/context.html
 *
 * Below are default params, according
 * to documentation this is more like interface
 */
export const AppContext = React.createContext({
  isSidebarOpen: true,
  toggleSidebar: () => {},
  openSidebar: () => {},
  closeSidebar: () => {},
  sidebarBreakpoint: 993
});

